import React from "react";

function AreaSort({ value, onChange, stateAbbr }) {
  return (
    <div className="area-sort">
      <form className="search-input-wrap">
        <label className="label-no-transform" htmlFor="area_sort">
          Show resources serving all of {stateAbbr || "CT"} and United States first
        </label>
        <span>
          <input
            className="input area-checkbox"
            name="area_sort"
            type="checkbox"
            id="area_sort"
            checked={!!value}
            onChange={(e) => onChange(e.target.checked)}
          />
        </span>
      </form>
    </div>
  );
}

export default AreaSort;
